module.exports = __webpack_public_path__ + "static/media/vertical_draft.e6c699cb.png";